import { Offer } from '../types/types';
import { IMAGE_BASE_URL } from '../constants/config';
import CouponsUsedCount from './CouponsUsedCount';
import OfferAction from './OfferAction.tsx';
import { isUserLoggedIn } from '../utils/auth.ts';
import useDynamicParamsLink from '../hooks/useDynamicParamsLink.ts';
import { Link } from 'react-router-dom';
import '../scss/offer.scss';

interface Props {
  offer: Offer;
  showButton?: boolean;
  isUserLoggedIn?: boolean;
  linkTo?: string;
  imgLoadingType?: 'lazy' | 'eager';
  imgFetchPriority?: 'high' | 'low';
  allowViewDetails?: boolean;
}

const SpecialOfferDisplay: React.FC<Props> = ({
  offer,
  imgLoadingType,
  imgFetchPriority,
  showButton = false,
  allowViewDetails = false
}) => {
  if (allowViewDetails) {
    return (
      <LinkWrapper offerId={offer.id}>
        <SpecialOfferDisplayView
          offer={offer}
          imgLoadingType={imgLoadingType}
          imgFetchPriority={imgFetchPriority}
          showButton={showButton}
          allowViewDetails={allowViewDetails}
        />
      </LinkWrapper>
    );
  }

  return (
    <PlainWrapper>
      <SpecialOfferDisplayView
        offer={offer}
        imgLoadingType={imgLoadingType}
        imgFetchPriority={imgFetchPriority}
        showButton={showButton}
        allowViewDetails={allowViewDetails}
      />
    </PlainWrapper>
  );
};

const SpecialOfferDisplayView: React.FC<Props> = ({ offer, imgLoadingType, imgFetchPriority, showButton = false }) => {
  return (
    <>
      <img
        className="offer__image"
        alt={`${offer.partner_name} - ${offer.name}`}
        src={`${IMAGE_BASE_URL}/${offer.image0}`}
        width={207}
        height={103}
        loading={imgLoadingType}
        fetch-priority={imgFetchPriority}
      />
      <section className="ps-2 pe-2 pb-2">
        <h3 className="offer__partner fz-16 mt-4 mb-2 font-yettel-bold">{offer.partner_name}</h3>
        <h4 className="offer__name mb-3 font-yettel-light">{offer.name}</h4>
        {showButton && <OfferAction offer={offer} isUserLoggedIn={Boolean(isUserLoggedIn)} displayedIn={'special'} />}
      </section>
      <section className="d-flex offer__info">
        {Boolean(offer.used_code_count) && <CouponsUsedCount usedCount={offer.used_code_count} />}
      </section>
    </>
  );
};

interface WrapperProps {
  children?: React.ReactNode;
}

const PlainWrapper: React.FC<WrapperProps> = ({ children }) => {
  return <div className="offer pb-2">{children}</div>;
};

const LinkWrapper: React.FC<WrapperProps & { offerId: string }> = ({ offerId, children }) => {
  const offerLink = useDynamicParamsLink('offerId', offerId);

  return (
    <Link to={offerLink} className="offer mb-2">
      {children}
    </Link>
  );
};

export default SpecialOfferDisplay;
